class MessageBar extends HTMLElement {
  constructor() {
    super();
    this.messageBar = this;
    this.closeButton = this.querySelector('.message-bar__close');

    if (!sessionStorage.getItem('hideMessageBar')) {
      this.show();
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hide());
    }
  }

  show() {
    this.style.display = 'block';
  }

  hide() {
    sessionStorage.setItem('hideMessageBar', 'true');
    this.style.display = 'none';
  }
}

// Register custom element for Shopify Dawn Theme
customElements.define('message-bar', MessageBar);
